import PlateFactory from './PlateFactory';

export default function PlateExperimentFactory(state,args){
  console.log({args});
  let { plateId } = args;

  return {
    plates:{
      [plateId]:PlateFactory(args)
    },
    variableMap:[],
  }
}
